import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { Box, Tabs, Tab, ListItem, Select, MenuItem } from "@mui/material";
import { connect } from "react-redux";
import ReportDialogBox from "../ReportDialogBox";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import UserDetailsServices from "../../../services/console_services/LoginLogot";
import TabsContent from "../TabsContent";

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0 7px",
    // paddingRight: "24px",
    whiteSpace: "nowrap",
  },
  tabContainer: {
    flex: 1,
    borderBottom: "2px solid #C6C7C8",
  },
  activeTab: {
    borderBottom: "5px solid #0067A1 !important",
    color: "#0067A1 !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    textTransform: "none !important",
  },
  inactiveTab: {
    color: "#333 !important",
    fontSize: "14px !important",
    textTransform: "none !important",
  },
  tabPanel: {
    padding: "0px !important",
  },
  indicator: {
    display: "none",
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    // '&.MuiOutlinedInput-root': {
    //     margin: "0px 17px",
    // },
    marginBottom: "10px",
  },
}));

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box pt={3} pl={1} pr={1} pb={3}>
        {children}
      </Box>
    )}
  </div>
);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  "aria-controls": `simple-tabpanel-${index}`,
});

const TabComponent = ({
  tabIndex,
  tabChange,
  KPIData,
  mapData,
  tabList,
  MapLoading,
  Module,
  graphViewTabList,
  KPILoading,
  setTabIndexAndName,
  handleViewPowerBi,
  moduleTabIndexChange
}) => {
  const classes = useStyles();
  // const { instance } = useMsal();
  const [open, setOpen] = useState(false);
  // const [activeValue, setActiveValue] = useState("all");
  // const reduxState = useSelector((state) => state);
  //const [tabIndex, setTabIndex] = useState(0);
  const navigate = useNavigate();
  const pathToTypeMap = {
    "/dom": "DOM",
    "/sno": "SNO",
    "/rr": "RR",
    "/dp": "DO",
    "/do": "DO",
    "/fgs": "FGS",
    "/cp": "CP",
    "/dip": "DIP",
    "/poos": "POOS",
    "/ff": "ff",
    "/ds": "DETENTION",
    "/if": "IF",
    "/nps": "NPS",
    "/iofpb": "IOFPB",
    "/slp": "SLP",
    "/iob": "IOB",
    // "/slp": "SLP",
    "/iof": "IOF",
    "/erm":"ERM",
    "/tm": "TM",

  };

  const typeValue = pathToTypeMap[window.location.pathname] || undefined;

  // let reduxTab = reduxState?.tabs?.tabName;
  // let moduleType;
  // if (reduxTab) {
  //   if (reduxTab === "DOM") { moduleType = "DOM";}
  //   if (reduxTab === "SNO") { moduleType = "SNO";}
  //   if (reduxTab === "RR") { moduleType = 'RR';}
  //   if (reduxTab === "Deployment Planning") { moduleType = "DP";}
  //   if (reduxTab === "Deployment Optimization") { moduleType = "DO";}
  //   if (reduxTab === "FG Salvage" || reduxTab === "FGS") { moduleType = "FGS";}
  //   if (reduxTab === "Capacity Planning") { moduleType = "CP";}
  //   if (reduxTab === "Distribution_Planning") { moduleType = "DIP";}
  //   if (reduxTab === "Potential Out Of Stock") { moduleType = "POOS";}
  //   if (reduxTab === "ff") { moduleType = "ff";}
  //   if (reduxTab === "nps") { moduleType = "NPS";}
  //   if (reduxTab === "IF") { moduleType = 'IF';}
  //   if (reduxTab === "SLP") { moduleType = 'SLP';}
  //   if (reduxTab === "IOF") { moduleType = 'IOF';}
  //   if (reduxTab === "ERM") { moduleType = 'ERM';}
  //   if (reduxTab === "TM") { moduleType = 'TM';}
  // }

  const handleChange = (_event, newValue) => {
    const navigationMap = {
      "Deployment Optimization": "/do",
      "Deployment Planning": "/dp",
      DOM: "/dom",
      SNO: "/sno",
      'RR': "/rr",
      "Capacity Planning": "/cp",
      Distribution_Planning: "/dip",
      "FG Salvage": "/fgs",
      "Potential Out Of Stock": "/poos",
      FF: "/ff",
      "Network Planning Simulation": "/nps",
      DETENTION: "/ds",
      "IF": "/if",
      "IOF-Prioritization": "/iof",
      "Service Level Prediction": "/slp",
      "IOFPB": "/iofpb",
      "TM": "/tm",
      "ERM":"/erm"
    };
    const selectedTab = tabList[newValue].name;


    const newPath = navigationMap[selectedTab];

    if (newPath) {
      navigate(newPath);
    }
    tabChange(newValue);
    setTabIndexAndName(selectedTab);
    moduleTabIndexChange(0);
  };

  useEffect(() => {
    const validPaths = ["/do", "/dom", "/cp", "/poos"];
    if (validPaths?.includes(window.location.pathname) && tabIndex === 0) {

      tabChange(1);
      setTabIndexAndName(tabList[1]?.name);
    }
    const validPaths3 = ["/nps", "/rr"];
    if (validPaths3?.includes(window.location.pathname) && tabIndex === 0) {
      tabChange(2);
      setTabIndexAndName(tabList[2]?.name);
    }
    // fetchCreateAlertsWithUser();
  }, [tabIndex, tabChange, setTabIndexAndName, tabList]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          className={classes.tabContainer}
          aria-label="simple tabs example"
          classes={{ indicator: classes.indicator }}
        >
          {tabList?.map((item, index) => (
            <Tab
              key={index}
              className={
                tabIndex === index ? classes.activeTab : classes.inactiveTab
              }
              label={item?.label}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
        <ReportDialogBox handleClose={handleClose} open={open} />
      </div>

      {tabList.map((_item, index) => (
        <TabPanel
          key={index}
          value={tabIndex}
          index={index}
          className={classes.tabPanel}
        >
          <TabsContent
            data={KPIData}
            KPILoading={KPILoading}
            mapData={mapData}
            tabIndex={tabIndex}
            tabList={tabList}
            MapLoading={MapLoading}
            Module={Module}
            graphViewTabList={graphViewTabList}
            type={typeValue}
            handleViewPowerBi={handleViewPowerBi}
          />
        </TabPanel>
      ))}
    </div>
  );
};

TabComponent.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
  setTabIndexAndName: PropTypes.func.isRequired,
  KPIData: PropTypes.object,
  mapData: PropTypes.array,
  tabList: PropTypes.array.isRequired,
  MapLoading: PropTypes.bool,
  Module: PropTypes.string,
  graphViewTabList: PropTypes.array,
  KPILoading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  setTabIndexAndName: (newValue) =>
    dispatch({ type: "TAB_NAME", payload: newValue }),
  moduleTabIndexChange: newValue => dispatch({ type: 'MODULE_TAB_INDEX', payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(TabComponent);
